import React, { useState } from 'react';

export function PhonePrefixSelector(props) {

  const [selectedPrefix, setSelectedPrefix] = useState(props.initialPrefix);
  const [prefixes] = useState(props.phonePrefixes);

  const handlePrefixChange = (event) => {
    setSelectedPrefix(event.target.value);
    props.onChange({
        prefixId: event.target.value, 
        prefixValue: event.target[event.target.selectedIndex].text
      });
  };

  return (
    <div className="form-field form-field__select">
      <select value={selectedPrefix} onChange={handlePrefixChange}>
        {prefixes.map((prefix) => (
          <option key={prefix.text} value={prefix.id}
            style={{ fontWeight: prefix.isPreferred ? 'bold' : 'normal' }}
          >
            {prefix.text}
          </option>
        ))}
      </select>
      <svg enableBackground="new 0 0 32 32" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><path d="m22.7 12.7-6.7 6.6-6.7-6.6" fill="none" stroke="#a12971" strokeMiterlimit="10" strokeWidth="2" /></svg>
    </div>
  );
}

